module.exports = __webpack_public_path__ + "img/small.ac7f371c.jpg";